/* Component Dependencies */
var signOutPageCreditCardOfferTemplate = require('templates/signOutPageCreditCardOffer-SPG.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  /**
   * Component type
   *
   * REMOVE THIS COMMENT BLOCK
   */
  type: 'signOutPageCreditCardOffer',

  /**
   * Add template names here with corresponding template files
   *
   * REMOVE THIS COMMENT BLOCK
   */
  template: {
    'signOutPageCreditCardOffe-SPG': signOutPageCreditCardOfferTemplate
  },

  /**
   * Subscribe to PubSub messages which can be triggered via:
   * this.pubsub.publish().
   *
   * Add MESSAGE_KEY to utils/pubsubMessageKeys.js unless already exists.
   *
   * subscribe: {
   *   'MESSAGE_KEY': '<method>',
   *   ...
   * }
   *
   * REMOVE THIS COMMENT BLOCK
   */
  subscribe: {
    'MESSAGE_KEY': 'testPubSub'
  },

  /**
   * Subscribe to DOM events here
   * Backbone-style
   *
   * events: {
   *   'click <selector>': '<method>',
   *   ....
   * }
   *
   * REMOVE THIS COMMENT BLOCK
   */
  events: {
    'click .testClass': 'testMethod'
  },

  /**
   * Used to remove previously bound methods from legacy.
   * To be removed once we are completely on XM pages.
   *
   * @param {Function} $ Legacy jQuery instance
   *
   * REMOVE THIS COMMENT BLOCK
   */
  unBindEvents: function($) {
    $('*[data-component-id="' + this.$el.data('component-id') + '"]').off();
    $('*[data-component-id="' + this.$el.data('component-id') + '"] *').off();
  },

  /**
   * First function called after initialization and legacy unbinding
   *
   * REMOVE THIS COMMENT BLOCK
   */
  bindEvents: function() {},

  /**
   * Sample callbacks for message subscriptions and events
   */
  testPubSub: function() {},
  testMethod: function() {}
});
